<template>
    <div class="outer-body" @keyup.enter="navigate()">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-12 mx-auto">
                    <div class="card-custom">
                        <div class="card-body">
                            <img
                                src="../assets/image/logo1.png"
                                alt="Login"
                                width="150"
                                style="display: block; margin: auto"
                            />
                            <p class="label-text">Email *</p>
                            <TextInput placeholder="Enter your email" v-model="email" />
                            <p class="label-text">Password *</p>
                            <TextInput placeholder="Enter your password" type="password" v-model="password" />
                            <div class="d-flex flex-row justify-content-between">
                                <p class="error-text">Forgot Password?</p>
                                <p class="error-text" @click="toggleUpdatePasswordModal()">Update Password?</p>
                            </div>
                            <Button
                                label="Login"
                                class="qb-btn qb-btn-primary-md mt-3"
                                :disabled="!isNotValidEntry"
                                @onClick="navigate()"
                                id="loginButton"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal @close="toggleUpdatePasswordModal" :modalActive="showUpdatePasswordModal">
            <h4>Update Password</h4>
            <hr />
            <TextInput label="User Mail*" type="text" v-model="userMail" />
            <TextInput label="Old Password*" type="password" v-model="oldpassword" />
            <TextInput label="New Password*" type="password" v-model="newpassword" />
            <TextInput label="Confirm Password*" type="password" class="mb-2" v-model="confirmpassword" />
            <p class="my-0 small-text">Password should contain atleast</p>
            <li class="small-text">One Capital letter</li>
            <li class="small-text">One Small letter</li>
            <li class="small-text">One Special letter</li>
            <li class="small-text mb-2">One Numeric</li>
            <p class="my-0 small-text mb-2">And Password length should be 8-20</p>
            <Button label="Update" class="qb-btn qb-btn-primary-md" @onClick="updatePassword()" id="updateButton" />
        </Modal>
    </div>
</template>

<script>
import Modal from '../components/ModalComponent.vue';
import Vue from 'vue';
import Button from '../components/ButtonComponent.vue';
import TextInput from '../components/TextFieldComponent.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('Auth');
const { mapActions: mapUserActions } = createNamespacedHelpers('User');
export default {
    name: 'LoginPage',
    data() {
        return {
            email: '',
            password: '',
            showUpdatePasswordModal: false,
            userMail: '',
            oldpassword: '',
            newpassword: '',
            confirmpassword: '',
            pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$'),
            passwordcheck: false,
        };
    },
    components: {
        Button,
        TextInput,
        Modal,
    },
    computed: {
        isNotValidEntry() {
            return this.email && this.email.length > 0 && this.password && this.password.length > 0;
        },
    },
    methods: {
        ...mapActions({
            setuser: 'SET_USER',
        }),
        ...mapUserActions({
            setPassword: 'UPDATE_PASSWORD',
        }),
        navigate() {
            if (this.email && this.password) {
                this.setuser({
                    payload: { emailId: this.email, password: this.password },
                    successCallback: (res) => {
                        console.log(res);
                        console.clear();
                        this.$router.push({ name: 'EnrolledTrainingPage' });
                    },
                    errorCallback: (err) => {
                        console.log(err);
                        console.clear();
                        Vue.$toast.error('Invalid Username or Password');
                    },
                });
            } else {
                Vue.$toast.error('Enter All the Fields');
            }
        },
        toggleUpdatePasswordModal() {
            this.showUpdatePasswordModal = !this.showUpdatePasswordModal;
        },
        validatecheck() {
            return (
                this.passwordcheck &&
                this.newpassword === this.confirmpassword &&
                this.newpassword.length >= 8 &&
                this.newpassword.length <= 20 &&
                this.newpassword &&
                this.oldpassword &&
                this.confirmpassword &&
                this.userMail
            );
        },
        updatePassword() {
            if (this.validatecheck()) {
                let payload = {
                    // userId:user.userId,
                    emailId: this.userMail,
                    oldPassword: this.oldpassword,
                    newPassword: this.newpassword,
                };
                console.log(payload);
                this.setPassword({
                    payload,
                    successcallback: (res) => {
                        if (res.data.status === 'OK') {
                            Vue.$toast.success('Password Updated Successfully');
                            this.newpassword = '';
                            this.oldpassword = '';
                            this.confirmpassword = '';
                            this.userMail = '';
                            this.toggleUpdatePasswordModal();
                            // Vue.$toast.warning("You will be logged out ,Please log in with the new password")
                        } else {
                            Vue.$toast.error(res.data.message);
                        }
                    },
                    errorcallback: (err) => {
                        console.log(err);
                        // Vue.$toast.error('Try Again');
                    },
                });
            } else {
                if (
                    this.newpassword && (!this.passwordcheck ||
                    !(this.newpassword.length >= 8 && this.newpassword.length <= 20))
                ) {
                    Vue.$toast.error('Password not in required format');
                }
                if (this.newpassword != this.confirmpassword) {
                    Vue.$toast.error("New Password and Confirm Password doesn't match");
                }
                if (!(this.newpassword && this.oldpassword && this.confirmpassword && this.userMail)) {
                    Vue.$toast.error('Fill all the fields');
                }
            }
        },
    },
    watch: {
        newpassword(val) {
            if (this.pattern.test(val)) {
                this.passwordcheck = true;
            } else {
                this.passwordcheck = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.outer-body {
    background-color: #ffffff;
    height: 100vh;
    padding-top: 100px;
}

.card-custom {
    -webkit-box-shadow: -1px 2px 17px 0px rgba(227, 227, 227, 1);
    -moz-box-shadow: -1px 2px 17px 0px rgba(227, 227, 227, 1);
    box-shadow: -1px 2px 17px 0px rgba(227, 227, 227, 1);
    border-radius: $field-border-radius;
    padding: 20px;
}

.label-text {
    font-size: $font-size-md;
    margin-top: 10px;
    margin-bottom: 10px;
}
.error-text {
    margin-top: 20px;
    margin-bottom: 0px;
    color: $dark-400;
    font-weight: $font-weight-normal-2;
    font-size: $font-size-md;
    &:hover {
        cursor: pointer;
        color: $dark-200;
    }
}
.small-text {
    font-size: $font-size-sm;
    color: $dark-200;
}
</style>
